import WorkFlowList from "./WorkFlowList";

export default WorkFlowList;



// WEBPACK FOOTER //
// ./src/components/WorkFlow/WorkFlowList/index.js